"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6012],{

/***/ 95976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YS": function() { return /* reexport */ FigureCaption; },
  "Ee": function() { return /* reexport */ NextImage; },
  "ZP": function() { return /* reexport */ Figure; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Figure/Figure.tsx



var _excluded = ["interactive", "elevation", "borderRadius", "alt"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}








var Figure = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var appearance = _ref2.appearance,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? "vertical" : _ref2$mode,
      overrides = _ref2.overrides,
      children = _ref2.children,
      _ref2$gridMaxSize = _ref2.gridMaxSize,
      gridMaxSize = _ref2$gridMaxSize === void 0 ? "max-content" : _ref2$gridMaxSize,
      _ref2$gridMinSize = _ref2.gridMinSize,
      gridMinSize = _ref2$gridMinSize === void 0 ? "200px" : _ref2$gridMinSize,
      className = _ref2.className;
  var figureAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var overridesCss = (0,react.useMemo)(function () {
    var keys = [];

    for (var key in overrides) {
      keys.push(key);
    }

    var overridesCss =
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)( true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);

    if (overrides) {
      overridesCss =
      /*#__PURE__*/

      /*#__PURE__*/
      (0,emotion_react_browser_esm/* css */.iv)(keys === null || keys === void 0 ? void 0 : keys.map(function (key) {
        return (
          /*#__PURE__*/

          /*#__PURE__*/
          (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up(key), "{grid-template-columns:", overrides[key] === "horizontal" ? "repeat(2, minmax(".concat(gridMinSize, ", ").concat(gridMaxSize, "))") : "unset", ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
        );
      }), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
    }

    return overridesCss; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overrides]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    mode: mode,
    ref: ref,
    overridesCss: overridesCss,
    gridMaxSize: gridMaxSize,
    gridMinSize: gridMinSize,
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: figureAppearance,
      children: children
    })
  });
});
var NextImage = function NextImage(_ref3) {
  var interactive = _ref3.interactive,
      _ref3$elevation = _ref3.elevation,
      elevation = _ref3$elevation === void 0 ? 1 : _ref3$elevation,
      _ref3$borderRadius = _ref3.borderRadius,
      borderRadius = _ref3$borderRadius === void 0 ? 8 : _ref3$borderRadius,
      _ref3$alt = _ref3.alt,
      alt = _ref3$alt === void 0 ? "" : _ref3$alt,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    interactive: interactive,
    elevation: elevation,
    borderRadius: borderRadius,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, _objectSpread({
      alt: alt
    }, rest))
  });
};

var BaseFigureCaption = function BaseFigureCaption(_ref4) {
  var _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? "pSmall" : _ref4$variant,
      children = _ref4.children,
      className = _ref4.className,
      tokens = _ref4.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCaption, {
    variant: variant,
    tag: "figcaption",
    className: className,
    tokens: tokens,
    children: children
  });
};

var FigureCaption = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFigureCaption, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60]
    };
  }
});

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("figure",  true ? {
  target: "ef47um02"
} : 0)("display:grid;gap:32px;justify-items:start;align-items:start;width:100%;", function (_ref5) {
  var mode = _ref5.mode,
      gridMaxSize = _ref5.gridMaxSize,
      gridMinSize = _ref5.gridMinSize;
  return mode === "horizontal" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("grid-template-columns:repeat(2, minmax(", gridMinSize, ", ", gridMaxSize, "));" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref6) {
  var overridesCss = _ref6.overridesCss;
  return overridesCss;
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "y41kzi",
  styles: "cursor:pointer;transition:box-shadow 0.3s ease;:hover{box-shadow:0px 3px 6px rgba(0, 0, 0, 0.02),0px 10px 19px rgba(7, 14, 74, 0.09),0px 41px 16px -39px rgba(53, 36, 70, 0.05);}"
} : 0;

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ef47um01"
} : 0)("display:grid;border-radius:", function (_ref7) {
  var borderRadius = _ref7.borderRadius;
  return borderRadius;
}, "px;filter:", function (_ref8) {
  var theme = _ref8.theme,
      elevation = _ref8.elevation;
  return "drop-shadow(".concat(theme.shadows[elevation], ")");
}, ";overflow:auto;", function (_ref9) {
  var interactive = _ref9.interactive;
  return interactive && _ref;
}, ";" + ( true ? "" : 0));

var StyledCaption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ef47um00"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

/* harmony default export */ var Figure_Figure = ((/* unused pure expression or super */ null && (Figure)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Figure/index.ts

Figure.displayName = "FigureBase";
NextImage.displayName = "Figure.Image";
FigureCaption.displayName = "Figure.Caption";


/***/ }),

/***/ 72791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Highlighter; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/highlight.js/es/index.js
var es = __webpack_require__(61183);
// EXTERNAL MODULE: ../../node_modules/highlight.js/styles/vs2015.css
var vs2015 = __webpack_require__(86624);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Highlighter/Highlighter.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("pre",  true ? {
  target: "en1wbuo2"
} : 0)("padding:30px;border-radius:10px;text-align:initial;white-space:pre-wrap;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{padding:10px;font-size:14px;}" + ( true ? "" : 0));
var CodeWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "en1wbuo1"
} : 0)( true ? {
  name: "1j3zebv",
  styles: "overflow-x:auto"
} : 0);
var Code = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("code",  true ? {
  target: "en1wbuo0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Highlighter/Highlighter.tsx





 // https://highlightjs.readthedocs.io/en/latest/supported-languages.html

var supportedLanguages = new Map([["javascript", "javascript"], ["js", "javascript"], ["xml", "xml"], ["mathml", "xml"], ["html", "html"], ["css", "css"], ["clike", "c"], ["svg", "svg"]]);
var unsupportedIndentationLanguages = ["makefile", "shell", "bash"];

var indentCode = function indentCode(content) {
  var spaceCount = 0;
  var space = 2;
  var openTagRegex = "(\\{|<[A-Za-z ]|<\\/[A-Za-z ]|\\[|\\()";
  var closeTagRegex = "(\\}|<\\/|[A-Za-z ]>|\\/>|\\]|\\))";
  var openCloseRegex = "^<.*\\/>$";
  var indentedContent = content.replace(/\t/g, "").split(/\r?\n/).map(function (line) {
    var _indentedLine$match, _indentedLine$match2, _indentedLine$match3;

    var indentedLine = line.trim();
    var openCount = (0,toConsumableArray/* default */.Z)(indentedLine.matchAll(new RegExp(openTagRegex, "g"))).length || 0;
    var closeCount = (0,toConsumableArray/* default */.Z)(indentedLine.matchAll(new RegExp(closeTagRegex, "g"))).length || 0;
    var openCloseCount = ((_indentedLine$match = indentedLine.match(openCloseRegex)) === null || _indentedLine$match === void 0 ? void 0 : _indentedLine$match.length) || 0;
    var isClosingFirst = openCount === closeCount && (((_indentedLine$match2 = indentedLine.match(closeTagRegex)) === null || _indentedLine$match2 === void 0 ? void 0 : _indentedLine$match2.index) || 0) < (((_indentedLine$match3 = indentedLine.match(openTagRegex)) === null || _indentedLine$match3 === void 0 ? void 0 : _indentedLine$match3.index) || 0);
    if (closeCount > openCount || isClosingFirst) spaceCount -= space;
    if (openCloseCount > 0) spaceCount += space;
    indentedLine = " ".repeat(spaceCount < 0 ? 0 : spaceCount) + indentedLine;
    if (openCloseCount > 0) spaceCount -= space;
    if (closeCount < openCount || isClosingFirst) spaceCount += space;
    return indentedLine;
  }).join("\n");
  return indentedContent;
};

var Highlighter = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var content = _ref.content,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? "javascript" : _ref$language;
  var supportedLanguage = supportedLanguages.get(language);
  var highlighted = supportedLanguage ? es/* default.highlight */.Z.highlight(indentCode(content), {
    language: supportedLanguage,
    ignoreIllegals: true
  }) : es/* default.highlightAuto */.Z.highlightAuto(content, unsupportedIndentationLanguages);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    ref: ref,
    className: "hljs",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CodeWrapper, {
      tabIndex: 0,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Code, {
        role: "code",
        dangerouslySetInnerHTML: {
          __html: highlighted.value
        }
      })
    })
  });
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Highlighter/index.ts


/***/ }),

/***/ 41835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98439);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);



var _excluded = ["tokens", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var BaseBlockquote = function BaseBlockquote(_ref) {
  var tokens = _ref.tokens,
      children = _ref.children,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Blockquote, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    children: children
  }));
};

var Blockquote = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("blockquote",  true ? {
  target: "e177des50"
} : 0)("padding-left:21px;border-left:", function (_ref2) {
  var borderColor = _ref2.borderColor;
  return "3px solid ".concat(borderColor);
}, ";margin:24px 0px;" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = ((0,_segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_2__/* .withDesignTokens */ .Y)(BaseBlockquote, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      borderColor: theme.palette.cdpWeek2023.gray[20]
    };
  }
}));

/***/ }),

/***/ 68134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89533);
/* harmony import */ var _segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98439);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseCodeBlock = function BaseCodeBlock(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      tag = _ref.tag,
      tokens = _ref.tokens;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledCodeBlock, _objectSpread(_objectSpread({}, tokens), {}, {
    variant: variant,
    tag: tag,
    children: children
  }));
};

var StyledCodeBlock = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,  true ? {
  target: "e113ig4i0"
} : 0)("padding:24px 16px;border:1px solid;border-radius:5px;font-size:14px;background:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";border-color:", function (_ref3) {
  var borderColor = _ref3.borderColor;
  return borderColor;
}, ";color:", function (_ref4) {
  var color = _ref4.color;
  return color;
}, ";" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = ((0,_segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_3__/* .withDesignTokens */ .Y)(BaseCodeBlock, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500],
      backgroundColor: theme.palette.neutrals.cloud[100],
      borderColor: theme.palette.brand.boysenberry[200]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.code.stone[10],
      backgroundColor: theme.palette.brand.darkAcai[700],
      borderColor: theme.palette.brand.darkAcai[800]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.code.gray[10],
      backgroundColor: theme.palette.neutrals.cloud[100],
      borderColor: theme.palette.twilio.boysenberry[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.code.gray[10],
      backgroundColor: theme.palette.neutrals.cloud[100],
      borderColor: theme.palette.twilio.boysenberry[20]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.code.gray[10],
      backgroundColor: theme.palette.neutrals.cloud[100],
      borderColor: theme.palette.twilio.boysenberry[20]
    };
  }
}));

/***/ }),

/***/ 62479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var _segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9381);
/* harmony import */ var _segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89533);
/* harmony import */ var _segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98439);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);


var _excluded = ["variant", "tag", "color", "children", "appearance", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var ColoredTypography = function ColoredTypography(_ref) {
  var variant = _ref.variant,
      tag = _ref.tag,
      color = _ref.color,
      children = _ref.children,
      externalAppearance = _ref.appearance,
      tokens = _ref.tokens,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var appearance = (0,_segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_1__/* .useAppearance */ .M)(externalAppearance);
  var appearanceColor = tag === "p" ? tokens.paragraphColor : tokens.defaultColor;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    tokens: {
      color: color || appearanceColor
    },
    variant: variant,
    tag: tag,
    appearance: appearance
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_3__/* .withDesignTokens */ .Y)(ColoredTypography, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      defaultColor: theme.palette.brand.darkAcai[700],
      paragraphColor: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      defaultColor: theme.palette.neutrals.white[100],
      paragraphColor: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      defaultColor: theme.palette.twilio.gray[100],
      paragraphColor: theme.palette.twilio.gray[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      defaultColor: theme.palette.twilio.gray[100],
      paragraphColor: theme.palette.twilio.gray[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      defaultColor: theme.palette.cdpWeek2023.gray[10],
      paragraphColor: theme.palette.cdpWeek2023.gray[10]
    };
  }
}));

/***/ }),

/***/ 39844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RichText_Hyperlink; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/Hyperlink.views.tsx


var StyledHyperlink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1yg7k2z0"
} : 0)("font-weight:400;font-size:inherit;padding:0;vertical-align:baseline;border-bottom:2px solid transparent;transition:300ms ease;&::after{content:none;}&:hover,&:focus{border-bottom:2px solid ", function (_ref) {
  var color = _ref.color;
  return color;
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/Hyperlink.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseHyperlink = function BaseHyperlink(_ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var linkColor = tokens.color && {
    color: tokens.color
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHyperlink, _objectSpread(_objectSpread(_objectSpread({}, rest), linkColor), {}, {
    children: children
  }));
};

var Hyperlink = (0,useDesignTokens/* withDesignTokens */.Y)(BaseHyperlink, function () {
  return {};
}, {
  light: function light() {
    return {
      color: undefined
    };
  },
  dark: function dark() {
    return {
      color: undefined
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.green[70]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.twilio.green[70]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.twilio.green[70]
    };
  }
});
/* harmony default export */ var RichText_Hyperlink = (Hyperlink);

/***/ }),

/***/ 16638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HC": function() { return /* binding */ ListItem; }
/* harmony export */ });
/* unused harmony export StyledListItem */
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98439);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var BaseList = function BaseList(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      tokens = _ref.tokens;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledList, _objectSpread(_objectSpread({}, tokens), {}, {
    as: tag,
    children: children
  }));
};

var StyledList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul",  true ? {
  target: "em9qucm2"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.pMedium;
}, ";padding-left:0;color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";margin:8px 0;list-style-position:inside;" + ( true ? "" : 0));

var ListItem = function ListItem(_ref4) {
  var children = _ref4.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledListItem, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ContentWrapper, {
      children: children
    })
  });
};
var StyledListItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "em9qucm1"
} : 0)("white-space:nowrap;max-width:100%;margin:8px 0;&,&::marker{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.pMedium.css;
}, ";}" + ( true ? "" : 0));

var ContentWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "em9qucm0"
} : 0)( true ? {
  name: "1073plb",
  styles: "white-space:normal;vertical-align:top;display:inline-block;width:calc(100% - 32px);p{margin:0;text-align:left;}"
} : 0);

/* harmony default export */ __webpack_exports__["ZP"] = ((0,_segment_matcha_useDesignTokens__WEBPACK_IMPORTED_MODULE_2__/* .withDesignTokens */ .Y)(BaseList, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.cdpWeek2023.gray[10]
    };
  }
}));

/***/ }),

/***/ 90494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RichText_RichText; }
});

// UNUSED EXPORTS: defaultOptions

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(20204);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Code/Code.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("code",  true ? {
  target: "ekfui1m0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.code;
}, ";border-radius:5px;padding:0px 4px;border:1px solid;word-break:break-all;border-radius:3px;font-weight:400;font-size:0.96em;line-height:inherit;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";border-color:", function (_ref4) {
  var borderColor = _ref4.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Code/Code.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseCode = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    ref: ref
  }, tokens), {}, {
    children: children
  }));
});
var Code = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCode, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[600],
      backgroundColor: theme.palette.brand.boysenberry[200],
      borderColor: theme.palette.brand.boysenberry[300]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.brand.boysenberry[600],
      borderColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[80],
      backgroundColor: theme.palette.twilio.gray[10],
      borderColor: theme.palette.twilio.gray[30]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Code/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Highlighter/index.ts + 2 modules
var Highlighter = __webpack_require__(72791);
// EXTERNAL MODULE: ../../libs/templates/Forms/ContentDownloadForm/index.ts + 3 modules
var ContentDownloadForm = __webpack_require__(59598);
// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/Blockquote.tsx
var Blockquote = __webpack_require__(41835);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/CodeBlock.tsx
var CodeBlock = __webpack_require__(68134);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/ColoredTypography.tsx
var ColoredTypography = __webpack_require__(62479);
// EXTERNAL MODULE: ../../libs/matcha/components/Figure/index.ts + 1 modules
var components_Figure = __webpack_require__(95976);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/Figure.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FigureWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9jjrbn0"
} : 0)( true ? {
  name: "5ogka4",
  styles: "margin:64px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/Figure.tsx





var Figure = function Figure(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      title = _ref.title,
      loader = _ref.loader,
      caption = _ref.caption;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FigureWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components_Figure/* default */.ZP, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Figure/* Image */.Ee, {
        src: src,
        width: width,
        height: height,
        alt: title || "",
        loader: loader
      }), caption && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Figure/* Caption */.YS, {
        children: caption
      })]
    })
  });
};

/* harmony default export */ var RichText_Figure = (Figure);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/List.tsx
var List = __webpack_require__(16638);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/index.ts + 8 modules
var TableBasic = __webpack_require__(87960);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/Table.tsx



var _renderNode;









var options = {
  renderNode: (_renderNode = {}, (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.TABLE_CELL, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Td, {
      vAlign: "top",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(_renderNode, dist.BLOCKS.PARAGRAPH, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledParagraph, {
      variant: "pMedium",
      tag: "p",
      children: children
    });
  }), _renderNode)
};

var Table = function Table(_ref) {
  var data = _ref.data;
  var filterTableFromData = (0,react.useMemo)(function () {
    return function () {
      return data.table.content.filter(function (table) {
        return table.nodeType === dist.BLOCKS.TABLE;
      })[0].content;
    };
  }, [data]);
  var columns = (0,react.useMemo)(function () {
    return function () {
      return filterTableFromData().flatMap(function (c) {
        return c.content;
      }).reduce(function (acc, d) {
        if (d && d.nodeType === dist.BLOCKS.TABLE_HEADER_CELL) {
          acc += 1;
        }

        return acc;
      }, 0);
    };
  }, [filterTableFromData]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyleTableBasic, {
    fixedLayout: true,
    borders: "all",
    size: columns(),
    snapping: columns() > 3,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic/* Head */.Fb, {
      zebra: true,
      sticky: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Tr, {
        sticky: false,
        children: filterTableFromData().map(function (content) {
          return content.content && content.content[0].nodeType === dist.BLOCKS.TABLE_HEADER_CELL && content.content.map(function (th, idx) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Th, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText_RichText, {
                data: th.content[0],
                options: options
              })
            }, idx);
          });
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic/* Body */.uT, {
      children: filterTableFromData().map(function (content, idxTr) {
        return content.content && content.content[0].nodeType !== dist.BLOCKS.TABLE_HEADER_CELL && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Tr, {
          children: content.content.map(function (tr, idx) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText_RichText, {
              data: tr,
              options: options
            }, idx);
          })
        }, idxTr);
      })
    })]
  });
};

/* harmony default export */ var RichText_Table = (Table);

var StyleTableBasic = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TableBasic/* default */.ZP,  true ? {
  target: "e1ph9byz1"
} : 0)(function (_ref2) {
  var size = _ref2.size;
  return size > 3 &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("min-width:calc(200px * ", size, ");" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var StyledParagraph = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1ph9byz0"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{margin-bottom:0;margin-top:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/Video.tsx


function Video_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}






var Video = function Video(_ref) {
  var data = _ref.data;
  var url = data.url;

  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledElevation, {
    elevation: 2,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* default */.ZP, {
      url: url,
      playing: playing,
      onPause: stop,
      onPlay: play,
      children: !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
        ariaLabel: "Play Button",
        onClick: play
      })
    })
  });
};

var StyledElevation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "ewdbmur0"
} : 0)( true ? {
  name: "5ogka4",
  styles: "margin:64px 0"
} : 0);

/* harmony default export */ var RichText_Video = (Video);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/RichText.views.tsx


function RichText_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Bold = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("b",  true ? {
  target: "e18mqg2l0"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/RichText/RichText.tsx


var _renderMark, RichText_renderNode;

function RichText_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function RichText_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? RichText_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RichText_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



















var defaultOptions = {
  renderMark: (_renderMark = {}, (0,defineProperty/* default */.Z)(_renderMark, dist.MARKS.CODE, function (text) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Code, {
      children: text
    });
  }), (0,defineProperty/* default */.Z)(_renderMark, dist.MARKS.BOLD, function (text) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bold, {
      children: text
    });
  }), _renderMark),
  renderNode: (RichText_renderNode = {}, (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HEADING_1, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "h1",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HEADING_2, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "h2",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HEADING_3, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "h3",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HEADING_4, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "h4",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HEADING_5, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "h5",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HEADING_6, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "h6",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.PARAGRAPH, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredTypography/* default */.Z, {
      variant: "pLarge",
      tag: "p",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.UL_LIST, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.ZP, {
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.OL_LIST, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.ZP, {
      tag: "ol",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.LIST_ITEM, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* ListItem */.HC, {
      children: react.Children.map(children, function (child) {
        if ( /*#__PURE__*/(0,react.isValidElement)(child)) {
          return /*#__PURE__*/(0,react.cloneElement)(child, RichText_objectSpread(RichText_objectSpread({}, child.props), {}, {
            variant: "pMedium"
          }));
        }
      })
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.INLINES.HYPERLINK, function (node, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      target: node.data.target || "_self",
      href: node.data.uri,
      "data-dynamic-link": "true",
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.EMBEDDED_ASSET, function (node) {
    var _node$data$target$fie = node.data.target.fields,
        file = _node$data$target$fie.file,
        title = _node$data$target$fie.title,
        description = _node$data$target$fie.description;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText_Figure, {
      src: file.url,
      width: file.details.image.width,
      height: file.details.image.height,
      title: title,
      loader: contentfulImageLoader/* default */.Z,
      caption: description
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.EMBEDDED_RESOURCE, function (node) {
    var _node$data, _node$data$target, _node$data$target$sys, _node$data$target$sys2, _node$data$target$sys3;

    var blockId = node === null || node === void 0 ? void 0 : (_node$data = node.data) === null || _node$data === void 0 ? void 0 : (_node$data$target = _node$data.target) === null || _node$data$target === void 0 ? void 0 : (_node$data$target$sys = _node$data$target.sys) === null || _node$data$target$sys === void 0 ? void 0 : (_node$data$target$sys2 = _node$data$target$sys.contentType) === null || _node$data$target$sys2 === void 0 ? void 0 : (_node$data$target$sys3 = _node$data$target$sys2.sys) === null || _node$data$target$sys3 === void 0 ? void 0 : _node$data$target$sys3.id;

    if (blockId === "downloadOnSubmitForm") {
      var _node$data2, _node$data2$target, _node$data2$target$fi, _node$data3, _node$data3$target, _node$data3$target$fi, _node$data4, _node$data4$target, _node$data4$target$fi, _node$data4$target$fi2, _node$data4$target$fi3, _node$data4$target$fi4, _node$data5, _node$data5$target, _node$data5$target$fi, _node$data6, _node$data6$target, _node$data6$target$fi;

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentDownloadForm/* default */.Z, {
        heading: node === null || node === void 0 ? void 0 : (_node$data2 = node.data) === null || _node$data2 === void 0 ? void 0 : (_node$data2$target = _node$data2.target) === null || _node$data2$target === void 0 ? void 0 : (_node$data2$target$fi = _node$data2$target.fields) === null || _node$data2$target$fi === void 0 ? void 0 : _node$data2$target$fi.header,
        description: node === null || node === void 0 ? void 0 : (_node$data3 = node.data) === null || _node$data3 === void 0 ? void 0 : (_node$data3$target = _node$data3.target) === null || _node$data3$target === void 0 ? void 0 : (_node$data3$target$fi = _node$data3$target.fields) === null || _node$data3$target$fi === void 0 ? void 0 : _node$data3$target$fi.description,
        image: node === null || node === void 0 ? void 0 : (_node$data4 = node.data) === null || _node$data4 === void 0 ? void 0 : (_node$data4$target = _node$data4.target) === null || _node$data4$target === void 0 ? void 0 : (_node$data4$target$fi = _node$data4$target.fields) === null || _node$data4$target$fi === void 0 ? void 0 : (_node$data4$target$fi2 = _node$data4$target$fi.image) === null || _node$data4$target$fi2 === void 0 ? void 0 : (_node$data4$target$fi3 = _node$data4$target$fi2.fields) === null || _node$data4$target$fi3 === void 0 ? void 0 : (_node$data4$target$fi4 = _node$data4$target$fi3.file) === null || _node$data4$target$fi4 === void 0 ? void 0 : _node$data4$target$fi4.url,
        assetUrl: node === null || node === void 0 ? void 0 : (_node$data5 = node.data) === null || _node$data5 === void 0 ? void 0 : (_node$data5$target = _node$data5.target) === null || _node$data5$target === void 0 ? void 0 : (_node$data5$target$fi = _node$data5$target.fields) === null || _node$data5$target$fi === void 0 ? void 0 : _node$data5$target$fi.downloadableAssetUrl,
        customFormIdentifier: node === null || node === void 0 ? void 0 : (_node$data6 = node.data) === null || _node$data6 === void 0 ? void 0 : (_node$data6$target = _node$data6.target) === null || _node$data6$target === void 0 ? void 0 : (_node$data6$target$fi = _node$data6$target.fields) === null || _node$data6$target$fi === void 0 ? void 0 : _node$data6$target$fi.formId
      });
    }
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.QUOTE, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blockquote/* default */.Z, {
      children: children
    });
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.HR, function () {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {});
  }), (0,defineProperty/* default */.Z)(RichText_renderNode, dist.BLOCKS.EMBEDDED_ENTRY, function (node) {
    var blockId = node.data.target.sys.contentType.sys.id;

    if (blockId === "codeBlock") {
      var code = node.data.target.fields.code;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CodeBlock/* default */.Z, {
        variant: "code",
        tag: "pre",
        children: code
      });
    }

    if (blockId === "codeSnippet") {
      var _node$data$target$fie2 = node.data.target.fields,
          _code = _node$data$target$fie2.code,
          language = _node$data$target$fie2.language;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Highlighter/* default */.Z, {
        content: _code,
        language: language
      });
    }

    if (blockId === "basicTable") {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText_Table, {
        data: node.data.target.fields
      });
    }

    if (blockId === "video") {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText_Video, {
        data: node.data.target.fields
      });
    }

    if (blockId === "embeddedVideo") {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText_Video, {
        data: {
          url: node.data.target.fields.embedUrl
        }
      });
    }

    if (blockId === "downloadOnSubmitForm") {
      var _node$data7, _node$data7$target, _node$data7$target$fi, _node$data8, _node$data8$target, _node$data8$target$fi, _node$data9, _node$data9$target, _node$data9$target$fi, _node$data9$target$fi2, _node$data9$target$fi3, _node$data9$target$fi4, _node$data10, _node$data10$target, _node$data10$target$f, _node$data11, _node$data11$target, _node$data11$target$f;

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentDownloadForm/* default */.Z, {
        heading: node === null || node === void 0 ? void 0 : (_node$data7 = node.data) === null || _node$data7 === void 0 ? void 0 : (_node$data7$target = _node$data7.target) === null || _node$data7$target === void 0 ? void 0 : (_node$data7$target$fi = _node$data7$target.fields) === null || _node$data7$target$fi === void 0 ? void 0 : _node$data7$target$fi.header,
        description: node === null || node === void 0 ? void 0 : (_node$data8 = node.data) === null || _node$data8 === void 0 ? void 0 : (_node$data8$target = _node$data8.target) === null || _node$data8$target === void 0 ? void 0 : (_node$data8$target$fi = _node$data8$target.fields) === null || _node$data8$target$fi === void 0 ? void 0 : _node$data8$target$fi.description,
        image: node === null || node === void 0 ? void 0 : (_node$data9 = node.data) === null || _node$data9 === void 0 ? void 0 : (_node$data9$target = _node$data9.target) === null || _node$data9$target === void 0 ? void 0 : (_node$data9$target$fi = _node$data9$target.fields) === null || _node$data9$target$fi === void 0 ? void 0 : (_node$data9$target$fi2 = _node$data9$target$fi.image) === null || _node$data9$target$fi2 === void 0 ? void 0 : (_node$data9$target$fi3 = _node$data9$target$fi2.fields) === null || _node$data9$target$fi3 === void 0 ? void 0 : (_node$data9$target$fi4 = _node$data9$target$fi3.file) === null || _node$data9$target$fi4 === void 0 ? void 0 : _node$data9$target$fi4.url,
        assetUrl: node === null || node === void 0 ? void 0 : (_node$data10 = node.data) === null || _node$data10 === void 0 ? void 0 : (_node$data10$target = _node$data10.target) === null || _node$data10$target === void 0 ? void 0 : (_node$data10$target$f = _node$data10$target.fields) === null || _node$data10$target$f === void 0 ? void 0 : _node$data10$target$f.downloadableAssetUrl,
        customFormIdentifier: node === null || node === void 0 ? void 0 : (_node$data11 = node.data) === null || _node$data11 === void 0 ? void 0 : (_node$data11$target = _node$data11.target) === null || _node$data11$target === void 0 ? void 0 : (_node$data11$target$f = _node$data11$target.fields) === null || _node$data11$target$f === void 0 ? void 0 : _node$data11$target$f.formId
      });
    }
  }), RichText_renderNode)
};

var RichText = function RichText(_ref) {
  var data = _ref.data,
      options = _ref.options;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(data, {
      renderNode: RichText_objectSpread(RichText_objectSpread({}, defaultOptions.renderNode), options === null || options === void 0 ? void 0 : options.renderNode),
      renderMark: RichText_objectSpread(RichText_objectSpread({}, defaultOptions.renderMark), options === null || options === void 0 ? void 0 : options.renderMark),
      renderText: options === null || options === void 0 ? void 0 : options.renderText
    })
  });
};

/* harmony default export */ var RichText_RichText = (RichText);

/***/ }),

/***/ 47756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* reexport safe */ _RichText__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "aV": function() { return /* reexport safe */ _List__WEBPACK_IMPORTED_MODULE_1__.ZP; },
/* harmony export */   "nW": function() { return /* reexport safe */ _Hyperlink__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "nq": function() { return /* reexport safe */ _ColoredTypography__WEBPACK_IMPORTED_MODULE_5__.Z; }
/* harmony export */ });
/* harmony import */ var _RichText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90494);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16638);
/* harmony import */ var _CodeBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68134);
/* harmony import */ var _Hyperlink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39844);
/* harmony import */ var _Blockquote__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41835);
/* harmony import */ var _ColoredTypography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62479);







/***/ }),

/***/ 80401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Disclaimer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/Hyperlink.tsx + 1 modules
var Hyperlink = __webpack_require__(39844);
;// CONCATENATED MODULE: ../../libs/templates/Disclaimer/Disclaimer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var FormCaptionLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hyperlink/* default */.Z,  true ? {
  target: "e1giqmq51"
} : 0)("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";text-decoration:underline;&:hover,&:focus{border-bottom:2px solid transparent;text-decoration:underline;}" + ( true ? "" : 0));
var FormCaption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1giqmq50"
} : 0)( true ? {
  name: "42eudr",
  styles: "margin:0;margin-bottom:15px;line-height:1.5;&:last-child{margin-bottom:0;}"
} : 0);
;// CONCATENATED MODULE: ../../libs/templates/Disclaimer/data.tsx

var data = {
  content: [{
    data: {},
    content: [{
      data: {},
      marks: [],
      value: "For information about how Segment handles your personal data, please see our ",
      nodeType: "text"
    }, {
      data: {
        uri: "https://www.twilio.com/legal/privacy/"
      },
      content: [{
        data: {},
        marks: [],
        value: "privacy policy",
        nodeType: "text"
      }],
      nodeType: dist.INLINES.HYPERLINK
    }, {
      data: {},
      marks: [],
      value: ".",
      nodeType: "text"
    }],
    nodeType: dist.BLOCKS.PARAGRAPH
  }],
  data: {},
  nodeType: dist.BLOCKS.DOCUMENT
};
/* harmony default export */ var Disclaimer_data = (data);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Disclaimer/Disclaimer.tsx








var renderDisclaimer = function renderDisclaimer(color) {
  var _ref;

  return _ref = {}, (0,defineProperty/* default */.Z)(_ref, dist.BLOCKS.PARAGRAPH, function (_, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormCaption, {
      tag: "p",
      variant: "pMedium",
      tokens: {
        color: color,
        linkColor: color,
        linkHoverColor: color
      },
      children: children
    });
  }), (0,defineProperty/* default */.Z)(_ref, dist.INLINES.HYPERLINK, function (node, children) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormCaptionLink, {
      size: "small",
      target: "_self",
      tag: "a",
      href: node.data.uri,
      color: color,
      children: children
    });
  }), _ref;
};

var BaseDisclaimer = function BaseDisclaimer(_ref2) {
  var tokens = _ref2.tokens,
      _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? Disclaimer_data : _ref2$data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
    data: data,
    options: {
      renderNode: renderDisclaimer(tokens.color)
    }
  });
};

var Disclaimer = (0,useDesignTokens/* withDesignTokens */.Y)(BaseDisclaimer, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.twilio.gray[10]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.twilio.gray[40]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/Disclaimer/index.ts


/***/ }),

/***/ 59598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ContentDownloadForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ContentDownloadForm/data.ts

var customDisclaimer = {
  content: [{
    data: {},
    content: [{
      data: {},
      marks: [],
      value: "We use your information according to our ",
      nodeType: "text"
    }, {
      data: {
        uri: "https://www.twilio.com/legal/privacy/"
      },
      content: [{
        data: {},
        marks: [],
        value: "Privacy Policy",
        nodeType: "text"
      }],
      nodeType: dist.INLINES.HYPERLINK
    }, {
      data: {},
      marks: [],
      value: ". You can update your preferences at any time.",
      nodeType: "text"
    }],
    nodeType: dist.BLOCKS.PARAGRAPH
  }],
  data: {},
  nodeType: dist.BLOCKS.DOCUMENT
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ContentDownloadForm/ContentDownloadForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1p366e32"
} : 0)( true ? {
  name: "3cgxep",
  styles: "display:flex;flex-wrap:wrap;gap:40px;margin-top:40px"
} : 0);
var FlexContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1p366e31"
} : 0)("flex:1 1 50%;max-width:calc(50% - 20px);box-sizing:border-box;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{flex:1 1 100%;max-width:100%;}" + ( true ? "" : 0));
var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1p366e30"
} : 0)("margin:56px 0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{margin:40px 0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ContentDownloadForm/ContentDownloadForm.tsx


var _excluded = ["appearance", "heading", "description", "image", "assetUrl"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var SUCCESS_MESSAGE = "Thank you for downloading this content. We've also sent a copy to your inbox.";
var BUTTON_TEXT = "Download Now";
var ContentDownloadForm = function ContentDownloadForm(_ref) {
  var appearance = _ref.appearance,
      heading = _ref.heading,
      description = _ref.description,
      image = _ref.image,
      assetUrl = _ref.assetUrl,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);

  var onSubmitHandler = function onSubmitHandler() {
    if (assetUrl) {
      window.open(assetUrl, "_blank");
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        children: heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
        variant: "pMedium",
        children: description
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
      children: [image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          src: image,
          alt: "Download asset image for ".concat(heading)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, _objectSpread({
          onSubmit: onSubmitHandler,
          customDisclaimer: customDisclaimer,
          buttonText: BUTTON_TEXT,
          successMessageDescription: SUCCESS_MESSAGE
        }, rest))
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {})]
  });
};
/* harmony default export */ var ContentDownloadForm_ContentDownloadForm = ((/* unused pure expression or super */ null && (ContentDownloadForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/ContentDownloadForm/index.ts


/***/ }),

/***/ 41948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EmailCaptureForm; },
  "t": function() { return /* reexport */ richTextDisclaimer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/EmailCaptureForm/EmailCaptureForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Compact = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebvxg823"
} : 0)("display:grid;gap:32px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{gap:8px;grid-template-columns:1fr auto;}" + ( true ? "" : 0));
var LoaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebvxg822"
} : 0)( true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0);
var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebvxg821"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebvxg820"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/EmailCaptureForm/EmailCaptureForm.tsx



var _excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "id", "additionalTrackEvent", "buttonText", "buttonUrl", "successButtonText", "successMessageAppearance", "successMessageHeading", "successMessageDescription", "loadingSuccess", "layout", "compact", "compactMessage", "borderlessMessage", "resourceType", "customDisclaimer", "customData", "onSubmit", "buttonColor", "inputProps", "displaySuccessMessage", "enableJobTitleField"];


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}























var schema = lib/* object */.Ry({
  email: lib/* string */.Z_().min(1, {
    message: FormFields/* companyEmailMessages.required */.BN.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* companyEmailMessages.invalid */.BN.invalid
  }).regex(email/* default */.Z, {
    message: FormFields/* companyEmailMessages.invalid */.BN.invalid
  }).regex(sharedEmail/* default */.C, {
    message: FormFields/* companyEmailMessages.sharedEmail */.BN.sharedEmail
  }),
  jobTitle: lib/* string */.Z_().min(1, {
    message: FormFields/* jobTitleMessages.required */.cY.required
  }).optional()
});
var EmailCaptureForm = function EmailCaptureForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? false : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email-capture-form" : _ref$id,
      additionalTrackEvent = _ref.additionalTrackEvent,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Download the report" : _ref$buttonText,
      buttonUrl = _ref.buttonUrl,
      successButtonText = _ref.successButtonText,
      successMessageAppearance = _ref.successMessageAppearance,
      successMessageHeading = _ref.successMessageHeading,
      successMessageDescription = _ref.successMessageDescription,
      _ref$loadingSuccess = _ref.loadingSuccess,
      loadingSuccess = _ref$loadingSuccess === void 0 ? false : _ref$loadingSuccess,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "row" : _ref$layout,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      _ref$compactMessage = _ref.compactMessage,
      compactMessage = _ref$compactMessage === void 0 ? false : _ref$compactMessage,
      _ref$borderlessMessag = _ref.borderlessMessage,
      borderlessMessage = _ref$borderlessMessag === void 0 ? false : _ref$borderlessMessag,
      _ref$resourceType = _ref.resourceType,
      resourceType = _ref$resourceType === void 0 ? "guide" : _ref$resourceType,
      customDisclaimer = _ref.customDisclaimer,
      customData = _ref.customData,
      onSubmitParent = _ref.onSubmit,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "primary" : _ref$buttonColor,
      inputProps = _ref.inputProps,
      _ref$displaySuccessMe = _ref.displaySuccessMessage,
      showSuccessMessage = _ref$displaySuccessMe === void 0 ? true : _ref$displaySuccessMe,
      _ref$enableJobTitleFi = _ref.enableJobTitleField,
      enableJobTitleField = _ref$enableJobTitleFi === void 0 ? false : _ref$enableJobTitleFi,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var scrollTo = (0,useScrollToAnchor/* default */.Z)("".concat(id, "-wrapper"), -96);
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance); // Initialize form methods

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  var successMessage = {
    heading: successMessageHeading || "You\u2019re all set!",
    description: successMessageDescription || "Check your inbox for an email confirmation with a link to the ".concat(resourceType, ". You can also click the link below to access now."),
    buttonUrl: buttonUrl,
    buttonText: successButtonText
  };

  var passJobTitleToTracking = function passJobTitleToTracking(data, customData) {
    if (enableJobTitleField) {
      return _objectSpread(_objectSpread({}, customData), {}, {
        jobTitle: data.jobTitle
      });
    }

    return customData;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "".concat(id, "-wrapper"),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        layout: layout,
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer || richTextDisclaimer(resourceType),
            appearance: successMessageAppearance
          }), after]
        }),
        success: showSuccessMessage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: loadingSuccess ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
            form: "emailCapture",
            status: "success",
            "data-hook": "email-capture-form-success-message",
            buttonColor: buttonColor,
            appearance: successMessageAppearance,
            compact: compactMessage,
            borderless: borderlessMessage
          }, successMessage))
        }),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "emailCapture",
          status: "error",
          "data-hook": "email-capture-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0,helpers/* trackEmailCaptureForm */.Ak)(data, additionalTrackEvent, passJobTitleToTracking(data, customData));

                  case 2:
                    if (isSmallResolution) scrollTo();
                    if (onSubmitParent) onSubmitParent(data);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [!compact && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, _objectSpread({
            id: "".concat(id, "-email-field")
          }, inputProps)), enableJobTitleField && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* JobTitle */.Xq, {
            label: "",
            placeholder: "Your job title"
          }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
            value: customFormIdentifier,
            id: id
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              color: buttonColor,
              variant: "filled",
              size: "large",
              expanded: true,
              children: buttonText
            })
          })]
        }), compact && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Compact, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, _objectSpread({
            id: "".concat(id, "-email-field")
          }, inputProps)), enableJobTitleField && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* JobTitle */.Xq, {
            label: "",
            placeholder: "Your job title"
          }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
            value: customFormIdentifier,
            id: id
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              color: buttonColor,
              variant: "filled",
              size: "large",
              expanded: true,
              children: buttonText
            })
          })]
        })]
      }))
    })
  });
};
/* harmony default export */ var EmailCaptureForm_EmailCaptureForm = ((/* unused pure expression or super */ null && (EmailCaptureForm)));
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ../../libs/templates/Forms/EmailCaptureForm/data.ts

var richTextDisclaimer = function richTextDisclaimer() {
  var resourceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "guide";
  return {
    data: {},
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "We\u2019ll share a copy of this ".concat(resourceType, " and send you content and updates about Twilio Segment\u2019s products as we continue to build the world\u2019s leading CDP. We use your information according to our "),
        nodeType: "text"
      }, {
        data: {
          uri: "https://www.twilio.com/legal/privacy/"
        },
        content: [{
          data: {},
          marks: [],
          value: "privacy policy",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: ".",
        nodeType: "text"
      }, {
        data: {},
        marks: [],
        value: " You can update your preferences at any time.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    nodeType: dist.BLOCKS.DOCUMENT
  };
};
;// CONCATENATED MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts



/***/ }),

/***/ 13206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export bannedUsernameEmails */
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7328);


var _templateObject;

var bannedUsernameEmails = ["info", "sales", "marketing", "support", "no-reply", "privacy", "webmaster", "admin", "editor", "hello", "contact", "hr", "example"];
var sharedEmailRegex = new RegExp(String.raw(_templateObject || (_templateObject = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(["^(?!.*(?:", ")@)[w-+.]+@([w-]+.)+[w-]{2,}"], ["^(?!.*(?:", ")@)[\\w-+.]+@([\\w-]+\\.)+[\\w-]{2,}"])), bannedUsernameEmails.join("|")), "gi");
/* harmony default export */ __webpack_exports__["C"] = (sharedEmailRegex);

/***/ })

}]);